<script></script>

<section id="">
    <div class="chatSection">

        <img class="imageRight" src="./Images/element3.svg" alt="">
        <img class="imageLeft" src="./Images/element2.svg" alt="">

        <div class="chat_container">
            <span class="rigth_chat">E o que isso significa para mim?</span>
            <span class="left_chat">
                Agilidade: Com a administração direta do gestor,<br/>
                as operações são mais rápidas.
            </span>
            <span class="left_chat">
                Segurança: Profissionais altamente qualificados que <br/>
                trabalham de acordo com o combinado.
            </span>
            <span class="left_chat">
                Independência: Você no controle da operação sem <br/>
                ter que se preocupar com ela.
            </span>
            <span class="rigth_chat">Como vocês fazem?</span>
            <span class="left_chat">
                Entendendo: Quem você é, onde quer chegar e <br/>
                como quer chegar.
            </span>
            <span class="left_chat">
                Planejando: Estratégias que façam sentido para as <br/>
                suas necessidades.
            </span>
            <span class="left_chat">
                Implementando: Execução da carteira e máximo <br/>
                aproveitamento das oportunidades.
            </span>
            <a class="knowMore" href="https://lp.asset.vlgi.com.br/fale-com-especialista" target="blank_"> Quero saber mais! </a>
        </div>
    </div>
</section>

<style lang="scss">
@use "../styles/variables" as v;

    section {
        margin-top: -5.8em;
    }

    .chatSection {
        position: relative;
        padding: 1rem;
        min-height: 100vh;
        background-color: #333333;

        .chat_container {
            position: relative;
            display: flex;
            flex-direction: column;
            row-gap: 1rem;
            width: 40rem;
            max-width: 100%;
            margin: 6rem auto;

            .rigth_chat, .left_chat, .knowMore {
                font-size: 1.25rem;
                padding: 1rem;
                width: fit-content;
            }

            .rigth_chat {
                color: black;
                background: white;
                border-radius: 30px 30px 0px 30px;
                margin-left: auto;
            }

            .left_chat {
                color: white;
                background: transparent;
                border: 2px solid white;
                box-sizing: border-box;
                border-radius: 35px 35px 35px 0px;
                margin-right: auto;
            }

            .knowMore {
                color: black;
                text-decoration: none;
                font-weight: bold;
                background: linear-gradient(90deg, #F5CFC2 0%, #8C66C9 100%);
                border-radius: 50px;
                margin-left: auto;
            }
        }
    }

    .imageRight {
        position: absolute;
        right: 0;
        bottom: 0;
    }

    .imageLeft {
        position: absolute;
        z-index: 1;
        left: 0;
        bottom: 0;
        transform: translateY(23%);
        max-width: 100%;
        max-height: 130%;
        display: none;
    }

    @media only screen and (min-width: v.$tablet-devices) {
        .chatSection {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            padding: 12rem;

            .chat_container {
                margin: 0 auto;
                .rigth_chat, .left_chat, .knowMore {
                    padding: 1rem 3rem;
                }
            }
        }
    }

    @media only screen and (min-width: v.$md-desktop-devices) {
        .imageLeft {
            display: block;
        }
    }
</style>
